export class CommentsConfig {
    visibility? : 'all' | 'public' | 'private' = 'private';
    privateIndication? : boolean = true;
}